export default () => {
    const newWindow = window.open()

    // TODO add preloader or something more efficient
    newWindow.document.write('loading...')

    return newWindow
}
